import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { apiFetch } from '../services/api';
import Navbar from '../components/Navbar';
import BottomNav from '../components/BottomNav';

export default function Notifications({ onBack, onTabChange, onOpenPackage, onOpenReport }) {
  const { token } = useAuth();
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  const cargar = () => {
    apiFetch('/notifications', {}, token)
      .then(data => { setNotifications(data); setLoading(false); })
      .catch(() => setLoading(false));
  };

  useEffect(() => { cargar(); }, [token]);

  const marcarLeida = async (id) => {
    await apiFetch(`/notifications/${id}/leer`, { method: 'PUT' }, token);
    setNotifications(prev => prev.map(n => n.id === id ? { ...n, leido: true } : n));
  };

  const borrarTodas = async () => {
    await apiFetch('/notifications/borrar-todas', { method: 'DELETE' }, token);
    setNotifications([]);
  };

  const handleClick = (n) => {
    if (!n.leido) marcarLeida(n.id);
    if (n.reportId && onOpenReport) {
      onOpenReport(n.reportId);
    } else if (n.packageId && onOpenPackage) {
      onOpenPackage(n.packageId);
    }
  };

  return (
    <div style={{minHeight:'100vh', backgroundColor:'#111318', paddingBottom:'96px'}}>
      <Navbar onOpenPackage={onOpenPackage} />

      <div style={{maxWidth:'480px', margin:'0 auto', padding:'20px 16px'}}>
        <div style={{display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'20px'}}>
          <div>
            <p style={{color:'#f97316', fontSize:'12px', fontWeight:'600', textTransform:'uppercase', letterSpacing:'0.08em', marginBottom:'4px'}}>
              Centro de avisos
            </p>
            <h1 style={{color:'white', fontWeight:'800', fontSize:'24px', letterSpacing:'-0.02em'}}>
              Notificaciones
            </h1>
          </div>
          {notifications.length > 0 && (
            <button onClick={borrarTodas}
              style={{backgroundColor:'#1a1d24', border:'1px solid #2a2d35', color:'#6b7280',
                fontSize:'12px', padding:'8px 14px', borderRadius:'10px', cursor:'pointer'}}>
              Borrar todo
            </button>
          )}
        </div>

        {loading && (
          <p style={{color:'#6b7280', fontSize:'14px', textAlign:'center', padding:'40px 0'}}>Cargando...</p>
        )}

        {!loading && notifications.length === 0 && (
          <div style={{textAlign:'center', padding:'60px 0'}}>
            <p style={{fontSize:'48px', marginBottom:'16px', opacity:0.2}}>🔔</p>
            <p style={{color:'#6b7280', fontSize:'14px'}}>No tienes notificaciones</p>
          </div>
        )}

        {notifications.map(n => (
          <div key={n.id}
            onClick={() => handleClick(n)}
            style={{
              backgroundColor: n.leido ? '#1a1d24' : '#1e2330',
              border: `1px solid ${n.leido ? '#2a2d35' : '#3b4a6b'}`,
              borderRadius:'14px', padding:'14px 16px', marginBottom:'8px',
              display:'flex', alignItems:'flex-start', gap:'12px',
              cursor: (n.packageId || n.reportId) ? 'pointer' : 'default',
              position: 'relative',
              zIndex: 1,
              transition:'border-color 0.2s'
            }}>
            <div style={{fontSize:'20px', flexShrink:0, marginTop:'2px'}}>
              {n.reportId ? '🚨' : '🔔'}
            </div>
            <div style={{flex:1, minWidth:0}}>
              <p style={{color: n.leido ? '#9ca3af' : 'white', fontSize:'13px', lineHeight:'1.5', marginBottom:'4px'}}>
                {n.mensaje}
              </p>
              <div style={{display:'flex', alignItems:'center', justifyContent:'space-between'}}>
                <p style={{color:'#3a3d45', fontSize:'11px'}}>
                  {new Date(n.createdAt).toLocaleDateString('es-ES', {day:'numeric', month:'short', hour:'2-digit', minute:'2-digit'})}
                </p>
                {n.reportId ? (
                  <span style={{color:'#f97316', fontSize:'11px', fontWeight:'600'}}>
                    Ver reporte →
                  </span>
                ) : n.packageId ? (
                  <span style={{color:'#f97316', fontSize:'11px', fontWeight:'600'}}>
                    Ver envío →
                  </span>
                ) : null}
              </div>
            </div>
            {!n.leido && (
              <div style={{width:'8px', height:'8px', borderRadius:'50%', backgroundColor:'#f97316', flexShrink:0, marginTop:'4px'}} />
            )}
          </div>
        ))}
      </div>

      <BottomNav active="notifications" onChange={onTabChange} unreadCount={0} />
    </div>
  );
}